module.exports = __webpack_public_path__ + "fonts/source-sans-pro-v21-latin-600.7cf79fbd.woff2";